'use client'

import _ from 'lodash'
import { useRouter } from 'next/navigation'

import { Box, Button } from '@/components'

export function PageOverLimit() {
  const router = useRouter()

  return (
    <Box className='mt-6 font-medium'>
      <div className='text-center'>
        <div className='pb-6'>
          We can only show top 10,000 results. Please refine your search criteria.
        </div>
        <Button type='button' onClick={() => router.back()}>
          Go Back
        </Button>
      </div>
    </Box>
  )
}